export const ugovor_o_najmu = {
    templateId: 49.1,
    category: 5,
    templateTitle: "Ugovor o najmu stvari",
    templateDescription: `<p>Ugovorom o najmu obvezuje se najmodavac predati određenu stvar najmoprimcu na uporabu, a ovaj mu se obvezuje za to plaćati određenu najamninu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovorom o najmu obvezuje se najmodavac predati određenu stvar najmoprimcu na uporabu, a ovaj mu se obvezuje za to plaćati određenu najamninu.</p>
    <p>Bitna razlika između najma i zakupa je u tome što najam ovlašćuje najmoprimca samo na uporabu, a zakup ovlašćuje zakupoprimca na uporabu i korištenje (crpljenje plodova).</p>
    <p>U slučaju da ugovorne strane ne odrede pobliže drugačije svoje obveze ugovorom, najmodavac sukladno Zakonu ima sljedeće obveze:</p>

    <li> predati stvar najmoprimcu,</li>
    <li> održavati stvar,</li>
    <li> snositi javne terete,</li>
    <li> suzdržavati se od izmjena predmeta najma,</li>

    <br>
    <p>dok s druge strane, najmoprimac ima sljedeće obveze:</p>
    <li> rabiti stvar na određeni način,</li>
    <li> snositi troškove uporabe,</li>
    <li> snositi troškove sitnih popravaka,</li>
    <li> vratiti predmet najma po prestanku najma.</li>
    <br>
    <p>Primjerom ugovora u nastavku uređuje se najam stvari te ga je bitno razlikovati od ugovora o najmu stana na koji se primjenjuju odredbe Zakona o najmu stanova.</p>

    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>-  Sklapanje ugovora najmu umjesto ugovora o zakupu</strong></p>
    <p>Pojašnjenje:  u slučaju da je pravna osoba vlasnik stana ili poslovnog prostora te isti daje na korištenje trećoj strani, zaključuje se ugovor o zakupu.</p>

    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

    sides: [
        {
            signature: 'Najmodavac:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa (za pr. osobe)",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija (za pr. osobe)",
                    inSignature: true,
                }],
            suffix: ' (u daljnjem tekstu: Najmodavac)',
            delimiter: `i`
        },
        {
            signature: 'Najmoprimac:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa (za pr. osobe)",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija (za pr. osobe)",
                    inSignature: true,
                }
            ],
            suffix: ' (u daljnjem tekstu: Najmoprimac),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR NAJMU STVARI',
    noArticleNumbers: false,

    articles: [
        {
            title: 'PREDMET NAJMA',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Najmodavac daje, a Najmoprimac prima u najam sljedeću stvar: '},
                        {type: 'textarea', value: '', required: true,},
                        
                      ],
                }],
            value: '',
        },
        {
            title: 'NAJAMNINA',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Ugovorne strane suglasno utvrđuju najamninu u iznosu od '},
                        {type: 'input', value: '', required: true,},
                        {type: 'text', content: ', za period od '},
                        {type: 'input', value: '', required: true,},
                        {help: "Upisujete razdoblje. Npr. mjesečno, tromjesečno,polugodišnje, godišnje i sl..",},
                      ],
                }],
            value: '',
        },
        {
            title: 'PLAĆANJE',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        { type: "text", content: "Najmoprimac je dužan plaćati najamninu Najmodavcu u sljedećim rokovima:" },
                        {type: "textarea", value: "", required: true },
                      ],
                }],
            value: '',
        },      
        {
            title: 'STANJE PREDMETA NAJMA',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Najmodavac predaje Najmoprimcu predmet najma u trenutku sklapanja ovog Ugovora bez oštećenja i u ispravnom stanju koje omogućuje njegovu redovitu uporabu.'},
                           ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Najmodavac predaje Najmoprimcu predmet najma u trenutku sklapanja ovog Ugovora sa sljedećim nedostacima:'},
                                {type: 'textarea', value: '', required: true},
                           ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Prilikom preuzimanja predmeta najma,  ugovorne strane će zapisnikom utvrditi stanje predmeta najma.', help: "Primjerak primopredajnog zapisnika možete pronaći u kategoriji PUNOMOĆI, ZAPISNICI."}
                            ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'PRIMOPREDAJA',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Mjesto primopredaje predmeta najma je'},
                        {type: 'input', value: '', required: true,},
                      ],
                },
                {
                    type: "text",
                    mandatory: true,
                    content: "\r\nPrimopredajom predmeta najma na Najmoprimca prelazi rizik propasti i oštećenja.",
                  },
            ],
            value: '',
        },
        {
            title: "ODRŽAVANJE",
            mandatory: false,
            statements: [
              {
                type: "text",
                mandatory: true,
                editable: true,
                content: "Najmoprimac se obvezuje redovito održavati predmet najma (obavljanje servisa i nužnih popravaka uzrokovanih redovitom uporabom), čuvati isti od oštećenja te snositi sve redovite troškove uporabe."},
              ]
          },
          {
            title: "POVRAT PREDMETA NAJMA",
            mandatory: false,
            statements: [
              {
                type: "text",
                mandatory: true,
                editable: true,
                content: "Po završenom najmu Najmoprimac se obvezuje vratiti Najmodavcu predmet najma u mjestu preuzimanja u istom onakvom stanju u kakvom ga je primio.\r\nNajmoprimac je dužan nadoknaditi svu nastalu štetu na predmetu najma uzrokovanu njegovom krivnjom.", help: "Primjerak primopredajnog zapisnika možete pronaći u kategoriji PUNOMOĆI, ZAPISNICI."},
              ]
          },
          {
            title: 'PODNAJAM',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Najmoprimac ne može predmet najma prepustiti na uporabu trećemu u podnajam bez pristanka Najmodavca.'},
                           ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Najmodavac ovim Ugovorom daje ovlaštenje Najmoprimcu da može predmet najma dati u podnajam trećim osobama. '},
                           ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Najmodavac ovim Ugovorom daje ovlaštenje Najmoprimcu da može predmet najma dati u podnajam trećim osobama, no o tome je dužan prethodno obavijestiti Najmodavca.'}
                            ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'TRAJANJE UGOVORA',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Ovaj ugovor se zaključuje na neodređeno vrijeme, počevši od'},
                                {type: 'input', value: '', required: true},                           ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Ovaj ugovor se zaključuje na određeno vrijeme i traje od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'do'},
                                {type: 'input', value: '', required: true},
                           ]
                        },
                       ],
                    value: '',
                }
            ]
        },
        {
            title: 'OTKAZ UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'Svaka ugovorna strana može jednostrano, pisanim putem, bez navođenja razloga, pisanim putem otkazati ovaj Ugovor uz otkazni rok od'
                        },
                        {type: 'input', value: '', required: true, help: 'Upisati otkazni rok.'},
                {type: 'text', content: ', a koji počinje teći od trenutka dostave otkaza drugoj ugovornoj strani.'},],
                }],
        },
        {
            title: 'RASKID UGOVORA',
            mandatory: false,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'U slučaju da jedna ugovorna strana krši obveze iz ovog Ugovora, druga ugovorna strana može pisanim putem raskinuti ugovor uz otkazni rok od 30 dana, a koji počinje teći od trenutka dostave obavijesti o raskidu drugoj ugovornoj strani.\r\nKršenjem obveza iz ovog Ugovora smatrati će se: \r\n- ukoliko Najmoprimac ne plaća najamninu sukladno odredbama ovog Ugovora, \r\n- Najmodavac koristi stvar protivno odredbama ovog Ugovora, \r\n- Najmodavac ometa Najmoprimca u uporabi stvari.',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: 'DOSTAVA',
            mandatory: false,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'U slučaju otkaza i raskida Ugovora, isti se mora drugoj ugovornoj strani dostaviti preporučenom pošiljkom putem pošte na adresu označenu u ovom Ugovoru ili na drugi pouzdan način.\r\nU slučaju nemogućnosti uredne osobne dostave pisane opomene i dostave otkaza zbog promjene adrese, odbijanja preuzimanja pismena ili drugih načina izbjegavanja primanja pismena, dostava se smatra uredno izvršenom danom predaje preporučene pošiljke pošti, bez obzira na to je li pošta bila u mogućnosti uručiti pisanu opomenu, odnosno otkaz ili drugo pismeno.  ',
                    value: '',
                },
            ],
            value: '',
        }, 
 
              {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Najmodavca.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Najmoprimca.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                           ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/49.1_ugovor_o_najmu.ts